var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowEnd2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 25.5,
    stroke: "#0F75BD",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 43C25.5 44.1046 26.3954 45 27.5 45C28.6046 45 29.5 44.1046 29.5 43H25.5ZM27.5 11L29.0537 9.74058C28.6739 9.27211 28.1031 9 27.5 9C26.8969 9 26.3261 9.27211 25.9463 9.74058L27.5 11ZM35.4463 23.9789C36.1419 24.837 37.4014 24.9687 38.2594 24.2731C39.1175 23.5776 39.2492 22.3181 38.5537 21.4601L35.4463 23.9789ZM16.4463 21.4601C15.7508 22.3181 15.8825 23.5776 16.7406 24.2731C17.5986 24.9687 18.8581 24.837 19.5537 23.9789L16.4463 21.4601ZM29.5 43V11H25.5V43H29.5ZM25.9463 12.2594L35.4463 23.9789L38.5537 21.4601L29.0537 9.74058L25.9463 12.2594ZM25.9463 9.74058L16.4463 21.4601L19.5537 23.9789L29.0537 12.2594L25.9463 9.74058Z",
    fill: "#0F75BD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowEnd2);
export default __webpack_public_path__ + "static/media/arrowEnd2.85b2b1598d1bd88e091efab27dc3eb17.svg";
export { ForwardRef as ReactComponent };